module.exports = __webpack_public_path__ + "img/account--avatar.29160dd9.svg";